import { RESPONSE_CODES } from "@simplyhealth/iam_client_lib";
import {
  CHECK_DETAILS_MESSAGE,
  TRY_AGAIN_LATER_MESSAGE,
  DEFAULT_PROBLEM_TITLE,
  sorryUnableTo,
  DETAILS_NOT_RECOGNISED_MESSAGE,
  DETAILS_ALREADY_EXIST_MESSAGE,
  CORPORATE_ADMINISTRATOR_ADVICE_MESSAGE,
  ACCOUNT_ALREADY_EXISTS_TITLE,
  TECH_GLITCH_MESSAGE,
  IF_FORGOTTEN_PASSWORD_LOGIN_MESSAGE,
  HINT_MESSAGE,
  CHECK_DETAILS_OR_REGISTER_MESSAGE
} from "../../../helpers/constants";

export function createUIMessageFromResponseCode(code: string = ""): [string[], string] {
  const messages = new Array<string>();
  let title = DEFAULT_PROBLEM_TITLE;

  const lowercaseCode = code.toLowerCase();
  switch (lowercaseCode) {
    case RESPONSE_CODES.SignIn_UserNotConfirmed.toLowerCase():
      messages.push(
        "Your online registration has not been completed.",
        "Please check your emails for a link to complete your registration. If you can't find this email, click the button below to resend."
      );
      break;
    case RESPONSE_CODES.SignIn_UserNotAuthorised.toLowerCase():
    case RESPONSE_CODES.SignIn_Error_Incorrect_Username_Password.toLowerCase():
      messages.push("Invalid email or password.", CHECK_DETAILS_MESSAGE, IF_FORGOTTEN_PASSWORD_LOGIN_MESSAGE);
      break;
    case RESPONSE_CODES.SignIn_Error_NoAccount.toLowerCase():
    case RESPONSE_CODES.ForgottenPassword_UserNotFound.toLowerCase():
      messages.push(DETAILS_NOT_RECOGNISED_MESSAGE, CHECK_DETAILS_OR_REGISTER_MESSAGE, HINT_MESSAGE);
      break;
    case RESPONSE_CODES.SignIn_Error_AccountType.toLowerCase():
      title = ACCOUNT_ALREADY_EXISTS_TITLE;
      messages.push(
        DETAILS_ALREADY_EXIST_MESSAGE,
        CHECK_DETAILS_OR_REGISTER_MESSAGE,
        CORPORATE_ADMINISTRATOR_ADVICE_MESSAGE
      );
      break;

    default:
      messages.push(sorryUnableTo("log you in"), TECH_GLITCH_MESSAGE, TRY_AGAIN_LATER_MESSAGE);
  }

  return [messages, title];
}

export function shouldShowResendVerification(code: string): boolean {
  return code === RESPONSE_CODES.SignIn_UserNotConfirmed;
}

export function createResendSuccessMessages(emailDestination: string): string[] {
  return [
    "Thanks for requesting a new verification email.",
    "You will shortly receive an email containing information to confirm your registration.",
    "The email will be sent to: " + emailDestination
  ];
}

export function createLoginSucessMessages(): string[] {
  return [
    "You have successfully logged in.",
    "Please use the smashing continue button to return back to whence you came."
  ];
}
